import {createContext, useContext, useMemo, useState} from 'react'

const SideMenuContext = createContext(undefined)

export const SideMenuProvider = ({children}) => {
    const [open, setOpen] = useState(false)
    const value = useMemo(
        () => ({
            open,
            setOpen,
        }),
        [open]
    )

    return <SideMenuContext.Provider value={value}>{children}</SideMenuContext.Provider>
}

export const useSideMenuContext = () => {
    const context = useContext(SideMenuContext)

    if (!context) {
        throw new Error('useSideMenuContext must be used within a SideMenuProvider')
    }

    return context
}
